import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import styles from './DeleteBillingAgreementDialog.styles.scss';
import cn from 'classnames';
import { AGREEMENT_TYPE } from '../../config/constants';

const DeleteBillingAgreementDialog = ({
  deleteRow,
  setDeleteRow,
  confirmDeleteAgreement,
}) => {
  const { t } = useTranslation();

  const agreementTypeLabel =
    deleteRow?.agreementType === AGREEMENT_TYPE.THIRD
      ? t('special_billing.third-party-billing-label')
      : t('special_billing.self-billing-label');

  return (
    <Dialog
      onHide={() => setDeleteRow(false)}
      className={cn(
        'rounded-4 overflow-hidden',
        styles.deleteBillingAgreementDialog,
      )}
      visible={!!deleteRow}
      footer={
        <>
          <Divider className="mb-4" />
          <div className="d-flex flex-row gap-4">
            <Button
              className="flex-grow-1"
              type="button"
              size="medium"
              label={t('common.cancel')}
              onClick={() => setDeleteRow(false)}
              outlined
            />{' '}
            <Button
              className="flex-grow-1"
              type="button"
              size="medium"
              label={t('common.confirm')}
              onClick={() => {
                confirmDeleteAgreement(deleteRow);
                setDeleteRow(false);
              }}
            />
          </div>
        </>
      }
    >
      <div className={styles.submissionMessage}>
        <span>
          <div>
            <i className="pi pi-trash" />
          </div>
        </span>
        <h2>{t('special_billing.remove-agreement')}</h2>
        <h3>
          {t('special_billing.delete_desc', { type: agreementTypeLabel })}
        </h3>
      </div>
    </Dialog>
  );
};

export default DeleteBillingAgreementDialog;
